module.exports = __webpack_public_path__ + "img/import-icon.977d6340.svg";